<template>
    <!-- 多个专家列表 -->
    <div class="expert-info-list">
        <div class="expert-info-list-title">专家阵容</div>
        <div class="expert-info-list-content">
            <div
                v-for="(item, index) in itemData"
                class="expert-info-list-content-item"
                @click="onDoctorDetails(item)"
                :key="index"
            >
                <van-image :src="item.avatar" width="48" height="52" round fit="cover" />
                <div class="expert-info-right">
                    <span>{{ item.name }}</span>
                    <span>{{ item.position }}</span>
                </div>
            </div>
        </div>
        <div class="expert-info-list-footer" v-if="itemData.length > 3">
            <span></span>
            <span></span>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        itemData: {
            type: Array,
            required: true
        }
    },
    methods: {
        onDoctorDetails(row) {
            this.$router.push({ name: 'doctor-details', params: { id: row.id } })
        }
    }
}
</script>

<style lang="scss" scoped>
.expert-info-list {
    padding-left: 18px;
    padding-bottom: 30px;
    background: #fff;

    &-footer {
        margin-top: 12px;
        display: flex;
        justify-content: center;
        span {
            display: inline-block;
            height: 4px;
            border-radius: 10px;
            &:nth-child(1) {
                width: 16px;
                background-color: #03cbbf;
            }
            &:nth-child(2) {
                width: 16px;
                background-color: #f1f2f4;
            }
        }
    }

    &-content {
        overflow-y: scroll;
        -webkit-overflow-scrolling: touch;
        padding-right: 14px;
        display: flex !important;

        &::-webkit-scrollbar {
            background-color: transparent;
            height: 0;
            width: 0;
        }
        .expert-info-right {
            display: flex;
            flex-direction: column;
            align-items: center;
            padding-left: 0px;
            padding-bottom: 10px;

            span:nth-child(2) {
                font-size: 12px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #9d9d9d;
            }
        }

        &-item {
            white-space: nowrap;
            background-color: #f7f7f8;
            height: 126px;
            padding: 0px 25px;
            display: flex;
            align-items: center;
            flex-direction: column;
            border-radius: 6px;
            margin: 0px 6px;

            .van-image {
                margin: 10px 0px;
            }

            span:nth-child(1) {
                margin-bottom: 5px;
            }
        }
    }

    &-title {
        font-family: PingFangSC-Regular;
        font-size: 19px;
        color: #222222;
        letter-spacing: 0;
        padding-top: 30px;
        padding-bottom: 16px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/expertInfo/list.vue